import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=6f6acf91&scoped=true&"
var script = {}
import style0 from "./ButtonList.vue?vue&type=style&index=0&id=6f6acf91&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6acf91",
  null
  
)

export default component.exports